// Port of src/app/components/nav-bar/background/background.component.{ts,html,scss}
// (mypart-background).

import './Background.scss';

export interface BackgroundProps {
  showBigSearchHomePage: boolean | undefined;
  isDragging: boolean;
}

export default function Background({ showBigSearchHomePage, isDragging }: BackgroundProps) {
  return (
    <>
      {showBigSearchHomePage && (
        <div className="bg-image-container">
          <div className="bg-image"></div>
        </div>
      )}
      {isDragging && (
        <div className="drag-overlay">
          <p className="text-[2rem] lg:text-[3rem]">Just drop your image or video here...</p>
        </div>
      )}
    </>
  );
}
